/**
 * Concept B — Product page enhancements
 * Collapsible color variant swatches (show first N visible, toggle rest)
 *
 * Strategy: inject a persistent CSS rule into <head> that hides swatches
 * beyond MAX_VISIBLE via nth-of-type. This survives theme re-renders and
 * prevents flicker. JS only manages the toggle button and expanded state.
 */
(function () {
  var MAX_VISIBLE = 21;
  var isApplying = false;
  var styleInjected = false;

  function injectCollapseCSS() {
    if (styleInjected) return;
    var style = document.createElement('style');
    style.id = 'swatch-collapse-css';
    style.textContent =
      '.swatch-collapse label:nth-of-type(n+' + (MAX_VISIBLE + 1) + '),' +
      '.swatch-collapse input:nth-of-type(n+' + (MAX_VISIBLE + 1) + ')' +
      '{ display: none !important; }' +
      '.swatch-collapse.swatch-expanded label:nth-of-type(n+' + (MAX_VISIBLE + 1) + '),' +
      '.swatch-collapse.swatch-expanded input:nth-of-type(n+' + (MAX_VISIBLE + 1) + ')' +
      '{ display: revert !important; }';
    document.head.appendChild(style);
    styleInjected = true;
  }

  function applyCollapsibleSwatches() {
    if (isApplying) return;
    isApplying = true;

    var fieldsets = document.querySelectorAll('.variant-picker__option');

    fieldsets.forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend || legend.textContent.trim().toLowerCase().indexOf('color') === -1) return;

      var grid = fieldset.querySelector('.variant-picker__option-values.wrap');
      if (!grid) return;

      var swatches = Array.from(grid.querySelectorAll('label'));
      if (swatches.length <= MAX_VISIBLE) return;

      // Add the CSS collapse class to the grid (hidden by persistent <style>)
      grid.classList.add('swatch-collapse');

      // Check if selected swatch is beyond MAX_VISIBLE — keep expanded if so
      var selectedIndex = -1;
      swatches.forEach(function (label, i) {
        var input = label.previousElementSibling;
        if (input && input.tagName === 'INPUT' && input.checked) {
          selectedIndex = i;
        }
      });

      if (selectedIndex >= MAX_VISIBLE) {
        grid.classList.add('swatch-expanded');
      }

      // Skip button creation if it already exists
      var existingBtn = fieldset.querySelector('.variant-picker__show-more');
      if (existingBtn) { isApplying = false; return; }

      var hiddenCount = swatches.length - MAX_VISIBLE;
      var expanded = selectedIndex >= MAX_VISIBLE;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'variant-picker__show-more';
      if (expanded) btn.classList.add('is-expanded');

      function updateBtn() {
        btn.innerHTML = expanded
          ? 'Show less <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>'
          : 'Show ' + hiddenCount + ' more <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>';
      }
      updateBtn();

      btn.addEventListener('click', function () {
        expanded = !expanded;
        grid.classList.toggle('swatch-expanded', expanded);
        btn.classList.toggle('is-expanded', expanded);
        updateBtn();
      });

      grid.parentNode.insertBefore(btn, grid.nextSibling);
    });

    isApplying = false;
  }

  function startObserver() {
    var timeout;
    var observer = new MutationObserver(function () {
      if (isApplying) return;

      // Immediately re-add collapse class to any Color grids (before paint)
      var fieldsets = document.querySelectorAll('.variant-picker__option');
      fieldsets.forEach(function (fieldset) {
        var legend = fieldset.querySelector('legend');
        if (!legend || legend.textContent.trim().toLowerCase().indexOf('color') === -1) return;
        var grid = fieldset.querySelector('.variant-picker__option-values.wrap');
        if (grid && grid.querySelectorAll('label').length > MAX_VISIBLE && !grid.classList.contains('swatch-collapse')) {
          grid.classList.add('swatch-collapse');
        }
      });

      // Debounce button recreation
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        var needsInit = false;
        fieldsets.forEach(function (fieldset) {
          var legend = fieldset.querySelector('legend');
          if (!legend || legend.textContent.trim().toLowerCase().indexOf('color') === -1) return;
          if (!fieldset.querySelector('.variant-picker__show-more')) {
            needsInit = true;
          }
        });
        if (needsInit) applyCollapsibleSwatches();
      }, 80);
    });

    var root = document.getElementById('main') || document.body;
    observer.observe(root, { childList: true, subtree: true });
  }

  // Inject CSS first — before any DOM parsing of variant pickers
  injectCollapseCSS();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyCollapsibleSwatches();
      startObserver();
    });
  } else {
    applyCollapsibleSwatches();
    startObserver();
  }

  document.addEventListener('shopify:section:load', applyCollapsibleSwatches);
})();
